import React, { Component } from 'react';
import './App.css';
import CAFFENIO from './assets/images/CAFFENIO_white.svg';
import BARRA from './assets/images/BARRA_white.svg';
import barras from './assets/images/barras.png'
import { Layout, Icon, Popover, Button, Divider } from 'antd';
import { BrowserRouter as Router, Switch } from 'react-router-dom';
import { checkToken, esBarras } from './util/generics';
import Menu from './components/Menu/Menu';
import Routs from './components/Routes/Routes';
import Login from './components/Login/Login';

const { Header, Sider, Content } = Layout;
const roles = localStorage.getItem("role")?.split(",");
// Probar diseño con varios roles
// const roles = ['Administrador', 'Operador', 'Supervisor']

/**
* Clase para ver el componente de app
*/
class App extends Component {
  state = {
    collapsed: false,
    mobile: false,
    loggedIn: false,
    segmento: -1
  };

  /**
  * Cambiar el estatus de abrir / cerrar menú
  */
  toggle = () => {
    this.setState({ collapsed: !this.state.collapsed });
  }

  /**
  * Función cuando carga el componente
  */
  componentDidMount() {
    let semnt = localStorage.getItem('segmento')
    this.changeCollapseWidth();
    //window.addEventListener("resize", this.changeCollapseWidth);
    if (checkToken()) {
      this.setState({ loggedIn: true, segmento: semnt})
    }
  }

  handleMenuClick = () => {
    if (this.state.mobile) {
      this.setState({ collapsed: true })
    }
  }

  /**
  * Función cuando sales del componente
  */
  componentWillUnmount() {
    window.removeEventListener("resize", this.changeCollapseWidth);
  }

  /**
  * Cambiar el with del menú
  */
  changeCollapseWidth = () => {
    let state = { ...this.state }
    let width = window.innerWidth;
    state.collapsed = false
    state.mobile = false
    if (width <= 800) {
      state.collapsed = true
      state.mobile = true
    }

    this.setState(state)
  }

  /**
  * Cerrar sesión del sistema
  */
  logout = () => {
    localStorage.clear()
    window.location.replace('/')
  }

  render() {
    const esBarra = esBarras()
    const content = (
      <div>
        {roles && roles.map((item, index) => <p key={index}>{item}</p>)}
        <Divider style={{margin: '12px 0'}} />
        <div className="btn-logout" onClick={this.logout}>
          <span className={this.props.collapsed ? "display-none" : ""}> Cerrar sesión</span>
        </div>
      </div>
    );
    return (
      <Router>
        <Switch>
          {
            this.state.loggedIn
              ? (
                <React.Fragment>
                  <Header style={{ background: '#6e6969', padding: 0, width: '100%' }}>
                    <Icon
                      className="trigger"
                      type={this.state.collapsed ? 'menu-unfold' : 'menu-fold'}
                      onClick={this.toggle}
                    />
                    <div className="tooltip-on">{this.state.collapsed ? "Mostrar menú" : "Ocultar menú"}</div>
                    <figure style={{ width: "170px", display: "inline-block", height: 'auto' }}>
                      {(this.state.segmento == 1)&&<img className="logo" src={CAFFENIO} alt="CAFFENIO"/>}
                      {(this.state.segmento == 2)&&<img className="logo" src={BARRA} alt="CAFFENIO" style={{marginBottom: "20px"}}/>}
                    </figure>
                    <Popover placement="bottomRight" title={'Roles asignados'} content={content} trigger="click">
                      <Button style={{position: 'absolute', right: '17px', top: '16px'}} >{localStorage.getItem("name")}</Button>
                    </Popover>
                  </Header>
                  <Layout style={{ minHeight: '100vh' }}>
                    <Sider
                      width={240}
                      style={{ background: "#FFF", borderRight: "1px solid #bbbbbb", paddingBottom: '50px' }}
                      breakpoint="lg"
                      {...(this.state.mobile ? { collapsedWidth: "0" } : {})}
                      trigger={null}
                      collapsible
                      collapsed={this.state.collapsed}
                    >
                      <p style={{ color: "black", textAlign: "center", fontSize: "22px", marginTop: "15px" }}>{this.state.collapsed ? "INV" : "Inventario"}</p>
                      <Menu
                        logout={this.logout}
                        collapsed={this.state.collapsed}
                        onMenuClick={this.handleMenuClick}
                      />
                    </Sider>
                    <Layout>
                      <Content style={{
                        margin: '24px 16px', padding: 24, background: '#fff', minHeight: 280,
                      }}
                      >
                        <Routs/>
                      </Content>
                    </Layout>
                  </Layout>
                </React.Fragment>
              )
              : <Login />
          }
        </Switch>
      </Router>
    );
  }
}

export default App;
